// (function () {
//     'use strict';

//     const module = angular.module('imApp');

//     module.component('checkListItemItems', {
//         templateUrl: 'views/components/views/checkListItemItems/checkListItemItems.template.html?v=' + module.version,
//         controllerAs: 'vm',
//         controller: ['$stateParams', 'stateService', 'checkListItemItemsService', function ($stateParams, stateService, checkListItemItemsService) {

//             // #region VARIABLES & DEFINITIONS

//             const vm = this;
//             let checkListItemKeyno = $stateParams.checklistitem_keyno;

//             vm.model = {
//                 filterValueButtons: [
//                     { id: 'erase', icon: 'fa fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.model.setting.filtervalue = '' }
//                 ],
//                 setting: {},
//                 itemsListCheckLists: [],
//                 orderingAlphabetically: false,
//                 orderingByType: false
//             };

//             // #endregion VARIABLES & DEFINITIONS

//             // #region LOAD PROCEDURE FUNCTIONS

//             async function loadSetting() {
//                 vm.model.setting = (await checkListItemItemsService.getSetting())[0];
//             }
            
//             async function loadCheckListItems() {
//                 vm.model.itemsListCheckLists = [];

//                 vm.model.itemsListCheckLists = await checkListItemItemsService.listCheckListItems({ checklistitem_keyno: checkListItemKeyno });
//             }

//             // #endregion LOAD PROCEDURE FUNCTIONS

//             // #region MULTI DIRECTION BUTTON FUNCTIONS

//             vm.goToFunc = function (state, e) {
//                 function go(parms) {
//                     if (e?.ctrlKey) {
//                         stateService.newTab(state, parms);
//                     } else {
//                         stateService.go(state, parms);
//                     }
//                 }

//                 switch (state) {
//                     case 'checklistitemitem':
//                         go({
//                             checklistitem_keyno: checkListItemKeyno,
//                             checklistitemitem_keyno: '0'
//                         });
//                         break;
//                     default:
//                         break;
//                 }
//             };

//             // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//             // #region ORDERING BUTTON FUNCTIONS

//             vm.orderAlphabetically = function () {
//                 vm.model.orderingAlphabetically = true;

//                 checkListItemItemsService.reorganizeCheckListItems({
//                     checklistitem_keyno: checkListItemKeyno,
//                     orderbytype: '',
//                     alpha: 'alpha'
//                 }).then(() => {
//                     vm.model.orderingAlphabetically = false;
//                     loadCheckListItems();
//                 }, () => vm.model.orderingAlphabetically = false);
//             }

//             vm.orderByType = function () {
//                 vm.model.orderingByType = true;

//                 checkListItemItemsService.reorganizeCheckListItems({
//                     checklistitem_keyno: checkListItemKeyno,
//                     orderbytype: 'orderby',
//                     alpha: ''
//                 }).then(() => {
//                     vm.model.orderingByType = false;
//                     loadCheckListItems();
//                 }, () => vm.model.orderingByType = false);
//             }

//             // #endregion ORDERING BUTTON FUNCTIONS

//             // #region ON INIT FUNCTION

//             vm.$onInit = async function () {
//                 loadSetting();
//                 loadCheckListItems();
//             }

//             // #endregion ON INIT FUNCTION

//         }]
//     });
// })();
